import { GisDaten, TaasVhvV2Data } from '@ps20/bff-models';
import { GisDatenVHV } from '@ps20-frontend/frontend-models';
import { isNumber } from '@allianz/ng-aquila/utils';

export function setGisDataToVhvData(
  taasVhvData: TaasVhvV2Data,
  gisDataFromState: GisDatenVHV,
): TaasVhvV2Data {
  if (gisDataFromState) {
    taasVhvData.gisDaten = {
      bachzone: gisDataFromState.bachzone,
      zuersGefaehrdungsklasse: gisDataFromState.zuersGefaehrdungsklasse,
      konvergenz150: setNumber(gisDataFromState.konvergenz150),
      konvergenz300: setNumber(gisDataFromState.konvergenz300),
      bewaldungsart20: setNumber(gisDataFromState.bewaldungsart20),
      bewaldungsart100: setNumber(gisDataFromState.bewaldungsart100),
      bewaldungsdichte: setNumber(gisDataFromState.bewaldungsdichte),
      bodenversiegelung: setNumber(gisDataFromState.bodenversiegelung),
      flutzone: setNumber(gisDataFromState.flutzone),
      gebaeudeGrundflaeche: setNumber(gisDataFromState.gebaeudeGrundflaeche),
      hoehe: setNumber(gisDataFromState.hoehe),
      landform: setNumber(gisDataFromState.landform),
      senke: setNumber(gisDataFromState.senke),
      starkregenzone: setNumber(gisDataFromState.starkregenzone),
      steigung: setNumber(gisDataFromState.steigung),
      latitude: gisDataFromState.latitude,
      longitude: gisDataFromState.longitude,
      matchcode: gisDataFromState.matchcode,
      buildingDensity100: setNumber(gisDataFromState.buildingDensity100),
      clayShare: setNumber(gisDataFromState.clayShare),
      heightAboveDrainage: setNumber(gisDataFromState.heightAboveDrainage),
      buildingFloors: gisDataFromState.buildingFloors ? gisDataFromState.buildingFloors : 1,
      precipitation50y: setNumber(gisDataFromState.precipitation50y),
      earthquakeZone: setNumber(gisDataFromState.earthquakeZone),
      gleitenderNeuwert: null,
    } as GisDaten;
  }

  return taasVhvData;
}

export function setNumber(arg: number): number {
  return isNumber(arg) ? arg : null;
}
